import React from 'react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center pt-24 pb-12 overflow-hidden bg-surface-deepest" data-id="element-94">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-95"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center mt-8" data-id="element-96">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-4" data-id="element-97">
          Domina los 17 <span className="text-gold italic" data-id="element-98">"Trucos"</span> de
          Psicología Social que te vuelven{' '}
          <span className="text-gold italic" data-id="element-99">Magnetismo Puro</span> para las{' '}
          <span className="text-pink-400" data-id="element-100">Mujeres</span>.
        </h1>

        <p className="font-body text-xl md:text-2xl text-gray-300 font-bold mb-8" data-id="element-101">
          (Incluso si te consideras tímido, introvertido o vergonzoso)
        </p>

        <button onClick={() => document.getElementById('deliverables-section')?.scrollIntoView({
        behavior: 'smooth'
      })} className="px-10 py-5 bg-red-600 hover:bg-red-700 text-white font-body font-bold text-lg rounded-xl transition-all duration-300 animate-heartbeat animate-pulse-red shadow-lg shadow-red-600/20 mb-8" data-id="element-102">
          SÍ, QUIERO SER UN HOMBRE MAGNÉTICO →
        </button>

        <p className="font-body text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-103">
          El protocolo exacto para dejar de ser el "amigo invisible" y
          convertirte en el hombre que ellas (y todos) notan al entrar a
          cualquier lugar. Sin frases ensayadas, solo presencia magnética.
        </p>
      </div>
    </section>;
}